"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapRootElement = void 0;
var wrap_root_element_1 = require("./wrap-root-element");
Object.defineProperty(exports, "wrapRootElement", { enumerable: true, get: function () { return wrap_root_element_1.wrapRootElement; } });
